import { Block, Flex } from '@aloft/toolkit-sui';

import React from 'react';

import { PropertyGrid } from '../../components/PropertyGrid/PropertyGrid.tsx';
import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { AdjustmentsToolbar } from '../adjustments/components/AdjustmentsToolbar.tsx';
import { AdjustmentsModuleTitle } from '../adjustments/internal/AdjustmentsModuleTitle.tsx';
import { AdjustmentsGridAdjustedSPSection } from './columnSections/AdjustmentsGridAdjustedSPSection.tsx';
import { AdjustmentsGridDateOfSaleSection } from './columnSections/AdjustmentsGridDateOfSaleSection.tsx';
import { AdjustmentsGridDepreciatedCostSection } from './columnSections/AdjustmentsGridDepreciatedCostSection.tsx';
import { AdjustmentsGridSiteExtractionSection } from './columnSections/AdjustmentsGridSiteExtractionSection.tsx';

export const AdjustmentsGridModule = React.memo(() => (
  <Flex
    {...useTkv2ReferenceBarEvents()}
    flexDirection="column"
    overflow="hidden"
    width="100%"
    gap={2}
  >
    <Block margin="10px 20px 0 10px">
      <AdjustmentsModuleTitle />
      <AdjustmentsToolbar />
    </Block>
    <Block overflow="auto" width="100%" paddingRight="10px">
      <PropertyGrid
        gridType="AdjustmentsGrid"
        columnSections={[
          AdjustmentsGridDateOfSaleSection,
          AdjustmentsGridSiteExtractionSection,
          AdjustmentsGridDepreciatedCostSection,
          AdjustmentsGridAdjustedSPSection,
        ]}
      />
    </Block>
  </Flex>
));
